import React from 'react';
import { Box, Card, CardContent, Typography, SvgIconProps } from '@mui/material';

interface FeatureCardProps {
  icon: React.ComponentType<SvgIconProps>;
  title: string;
  description: string;
  gradient?: boolean;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon: Icon,
  title,
  description,
  gradient = false,
}) => {
  return (
    <Card
      sx={{
        height: '100%',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 12px 40px rgba(100, 181, 246, 0.2)',
          borderColor: 'primary.main',
        },
      }}
    >
      <CardContent sx={{ p: 4 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 3,
            background: gradient
              ? 'linear-gradient(135deg, #64b5f6 0%, #f48fb1 100%)'
              : 'rgba(100, 181, 246, 0.15)',
          }}
        >
          <Icon
            sx={{
              fontSize: 32,
              color: gradient ? 'white' : 'primary.main',
            }}
          />
        </Box>
        <Typography variant="h5" gutterBottom fontWeight={600}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default FeatureCard;
